export var BpmxObject;
(function (BpmxObject) {
    let Geometry;
    (function (Geometry) {
        /**
         * Attributes for each geometry
         */
        let GeometryType;
        (function (GeometryType) {
            /**
             * Geometry has SDEF data
             */
            GeometryType[GeometryType["HasSdef"] = 1] = "HasSdef";
            /**
             * Geometry is indexed
             */
            GeometryType[GeometryType["IsIndexed"] = 2] = "IsIndexed";
            /**
             * Geometry has edge scale
             */
            GeometryType[GeometryType["HasEdgeScale"] = 4] = "HasEdgeScale";
        })(GeometryType = Geometry.GeometryType || (Geometry.GeometryType = {}));
        /**
         * Index element type
         */
        let IndexElementType;
        (function (IndexElementType) {
            /**
             * 32-bit signed integer
             */
            IndexElementType[IndexElementType["Int32"] = 0] = "Int32";
            /**
             * 32-bit unsigned integer
             */
            IndexElementType[IndexElementType["Uint32"] = 1] = "Uint32";
            /**
             * 16-bit unsigned integer
             */
            IndexElementType[IndexElementType["Uint16"] = 2] = "Uint16";
        })(IndexElementType = Geometry.IndexElementType || (Geometry.IndexElementType = {}));
    })(Geometry = BpmxObject.Geometry || (BpmxObject.Geometry = {}));
    let Image;
    (function (Image) {
        /**
         * Flag of the image
         */
        let Flag;
        (function (Flag) {
            /**
             * Has mime type
             */
            Flag[Flag["HasMimeType"] = 1] = "HasMimeType";
        })(Flag = Image.Flag || (Image.Flag = {}));
    })(Image = BpmxObject.Image || (BpmxObject.Image = {}));
    let Texture;
    (function (Texture) {
        /**
         * Flag of the texture
         */
        let Flag;
        (function (Flag) {
            /**
             * Disable mipmap
             */
            Flag[Flag["NoMipmap"] = 1] = "NoMipmap";
            /**
             * Invert Y axis of the texture
             */
            Flag[Flag["InvertY"] = 2] = "InvertY";
        })(Flag = Texture.Flag || (Texture.Flag = {}));
    })(Texture = BpmxObject.Texture || (BpmxObject.Texture = {}));
})(BpmxObject || (BpmxObject = {}));
